import type {
	LighthouseAuditDetails,
	LighthouseCategory,
} from "../types/analyzer";
import { getScoreColor } from "../utils/scores";

interface PerformanceProps {
	performanceCategory: LighthouseCategory;
	audits: Record<string, LighthouseAuditDetails>;
}

function Performance({ performanceCategory, audits }: PerformanceProps) {
	const weightedAuditRefs = performanceCategory.auditRefs.filter(
		(auditRef) => auditRef.weight > 0
	);

	const scoreByAudit = weightedAuditRefs.reduce<Record<string, number>>(
		(acc, auditRef) => {
			acc[auditRef.id] = audits[auditRef.id]?.score ?? 1;
			return acc;
		},
		{}
	);

	const overallScore = Math.round((performanceCategory.score ?? 0) * 100);

	return (
		<section className="results-section" id="performance">
			<header className="results-section__header">
				<div>
					<p className="eyebrow">Performance</p>
					<h3>Factores con mayor peso en Lighthouse</h3>
				</div>
				<span
					className="badge badge--score"
					style={{
						color: getScoreColor(performanceCategory.score ?? 0),
					}}
				>
					{overallScore}
				</span>
			</header>

			<div className="audit-stack">
				{weightedAuditRefs.map((auditRef) => (
					<article key={auditRef.id} className="audit-card">
						<header className="audit-card__header">
							<h4>{auditRef.id.replaceAll("-", " ")}</h4>
							<span
								style={{
									color: getScoreColor(scoreByAudit[auditRef.id]),
								}}
							>
								{parseFloat(
									(scoreByAudit[auditRef.id] * auditRef.weight).toFixed(2)
								)}{" "}
								/ {auditRef.weight}
							</span>
						</header>
						<div className="audit-card__body">
							{auditRef.relevantAudits?.map((auditId) => {
								const audit = audits[auditId];
								if (!audit) {
									return null;
								}
								return (
									<div key={auditId} className="audit-chip">
										<p className="audit-chip__title">{audit.title}</p>
										<p className="audit-chip__description">
											{audit.description.replace(/\[.*/, "")}
										</p>
									</div>
								);
							})}
						</div>
					</article>
				))}
			</div>
		</section>
	);
}

export default Performance;
